import { createSelector } from '@reduxjs/toolkit';
import { Status } from 'client/voladeum/statuses/types';
import { RootState } from 'store';

const statusesSlice = (state: RootState) => state.statuses;

export const selectStatuses = createSelector([statusesSlice], (state): Status[] => state);

export const selectValidationStatus = createSelector([selectStatuses], (statuses): Status[] =>
  statuses.filter((status) => [102, 201, 301, 401, 702, 802].includes(status.status_id))
);

export const selectStrategyStatus = createSelector([selectStatuses], (statuses): Status[] =>
  statuses.filter((status) => [103, 901].includes(status.status_id))
);

export const selectCandleWorkerStatus = createSelector([selectStatuses], (statuses): Status[] =>
  statuses.filter((status) => [102, 301, 401, 402, 802].includes(status.status_id))
);
